/*
 * @Author: xuanyu 969718197@qq.com
 * @Date: 2023-09-20 14:27:20
 * @LastEditors: xuanyu 969718197@qq.com
 * @LastEditTime: 2023-09-20 14:29:06
 * @FilePath: \official-website\src\utils\file.js
 * @Description: 文件函数工具
 */
/**
 * 压缩图片
 * @export
 * @param {*} file 文件对象
 * @param {number} [quality=0.5] // 压缩精度
 * @return {*} 
 */
export function compressImage(file, quality = 0.5) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = function (e) {
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const compressedDataUrl = canvas.toDataURL("image/jpeg", quality);
      resolve(compressedDataUrl);
    };
    img.onerror = reject;
  });
}
